import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { FeatureFlagService } from '../../util/feature-flag.service';

@Injectable({
  providedIn: 'root',
})
export class LandingRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService
  ) {}

  canActivate(): UrlTree {
    const destination = this.featureFlagService.flagEnabled('vitals-dashboard')
      ? '/dashboard'
      : '/map';
    return this.router.parseUrl(destination);
  }
}
